import React, {useState, useCallback, useEffect} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {clientMergeMaxAction} from "../../../actions/clientAction";
import {InputProfile} from "../../../utils/input/InputProfile";

export function ClientMergeMaxModal({clientId, trigger, handleComplete}) {
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const value = e.target.value;
    setPhone(value);
  }, []);

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let errs = {};
    if (phone.trim() === '') {
      errs.phone = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);

    dispatch(clientMergeMaxAction(clientId, phone)).then(() => {
      setLoading(false);
      setOpen(false);
      handleComplete({channel_type: 'M'});
    }).catch((e) => {
      setLoading(false);
      try {
        const res = JSON.parse(e.message);
        if (res && res.error) {
          toast.error(formatErrors([res.error]), {position: toast.POSITION.BOTTOM_RIGHT});
        } else {
          toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        }
      } catch (error) {
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
    });
  };

  useEffect(() => {
    if (open) {
      setPhone('');
      setErrors({});
    }
  }, [open]);

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title modal__title--mb">Склеить клиентов с переключением канала</div>
      <React.Fragment>
        <div className="modal__scroll">
          <div className="modal__wrap">
            <InputProfile type="text"
                title="Телефон для аккаунта Макс"
                name="phone"
                placeholder="Введите телефон"
                value={phone}
                error={errors.phone || false}
                disabled={loading}
                onChange={handleChangeForm}/>
                          
          </div>
        </div>
        <div className="modal__btns">
          <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Продолжить</button>
        </div>
      </React.Fragment>
    </React.Fragment>
  </Modal>
};
